import React, {
    useState,
    useEffect,
    useContext,
    ChangeEvent,
} from 'react'

import * as Contexts from '../../contexts'
import * as Page from '../../components/Page'
import * as Buttons from '../../components/Buttons'
import * as Components from './components'

import { config, Translater } from '../../config'
import { useHttp } from '../../hooks/http.hook'
import { IRestaurant } from '../../types/items'
import { useHistory } from 'react-router-dom'


const CreatePage: React.FC = () => {

    const { token } = useContext(Contexts.AuthContext)
    const { language } = useContext(Contexts.LanguageContext)

    const history = useHistory()
    const { loading, request } = useHttp()

    const [isValid, toggleValid] = useState({
        title: false,
        city: false,
    })

    const [form, setForm] = useState<IRestaurant>({
        title: '',
        city: '',
    })

    const Events = {
        inputHandler: (e: ChangeEvent<HTMLInputElement>) => {
            setForm({ ...form, [e.target.name]: e.target.value })
        },
        selectHandler: (e: ChangeEvent<HTMLSelectElement>) => {
            setForm({ ...form, [e.target.name]: e.target.value })
        },
        setCity: (city: string) => {
            setForm({ ...form, city})
        },
      /*  setRole: (role: string) => {
            setForm({ ...form, role })
        }, */
        createHandler: () => {
            let isRight = false

            for (let key in isValid) {
                //@ts-ignore
                const value = isValid[key]
                if (value) isRight = true
                else {
                    isRight = false
                    break
                }
            }

            if (isRight) Callbacks.Create()
        }
    }

    const Callbacks = {
        Create: async () => {
            try {
                const response = await request(`${config.API}/restaurants`, 'POST', { ...form }, {
                    Authorization: (token as string),
                })

                if (response.title) {
                    history.goBack()
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    useEffect(() => {
        if (form.title.length >= 3) toggleValid({ ...isValid, title: true })
        else toggleValid({ ...isValid, title: false })
    }, [form.title])

    useEffect(() => {
        if (form.city) toggleValid({ ...isValid, city: true })
        else toggleValid({ ...isValid, city: false })
    }, [form.city])


    return (
        <Page.Wrapper
            title={Translater.RestaurantsCreatePage.title[language.slug]}
        >
            <Page.Header
                backButtonTitle={Translater.RestaurantsCreatePage.title[language.slug]}
            />

            <Buttons.Container
                disabled={loading}
                createHandler={Events.createHandler}
            />

            <Components.ConfigBlock
                isCreate
                form={form}
                isValid={isValid}
                setCity={Events.setCity}
                inputHandler={Events.inputHandler}
                selectHandler={Events.selectHandler}
            />

        </Page.Wrapper>
    )
}

export default CreatePage
